export default class LoginRequest {
    account;
    password;


    constructor(account, password) {
        this.account = account;
        this.password = password;
    }
}